<template>
    <div class="accident-item-container" id="accident-item-container">
        <div class="accident-item-infomation" @click.stop="showDetail(data.code)">
            <div class="accident-item-img-warpper">
                <el-badge is-dot :hidden="data.isRead" class="accident-item-badge">
                    <img :src="img">
                </el-badge>
            </div>
            <div class="accident-item-content">
                <div class="accident-item-name">{{data.name}}<span v-if="data.name">-</span>{{data.type}}</div>
                <div class="accident-item-time">{{data.start | diff}}</div>
            </div>
        </div>
        <div class="accident-item-operation" @click.stop="showDetail(data.code)">
            <div class="accident-item-delete" @click.stop="remove(data.code)">删除</div>
            <div>
                <img :src="require('../../assets/img/下箭头（选择）.png')">
            </div>
        </div>
        <Details v-if="isShowDetail" :dialogVisible="isShowDetail" :status="accidentDetailStatus" :detail="detail"
            @closeDetail="closeDetail" />
    </div>
</template>
<script>
    import dateTimeStamp from '../../util/DateDiff';
    // import Details from '../../components/accidentManagement/Details';
    
    import Details from '../../components/accidentManagement/UnconfirmedEvent/Details';
    import {
        GetAccidentDetailForId,
        GetAccidentValue,
        SetAccidentRead
    } from '../../api/accident';
    const IMAGE = {
        TELEMETRY_OVERRUN: require('../../assets/img/越限.png'),
        EQUIPMENT_FAILURE: require('../../assets/img/离线2.png'),
        TELEMETRY_DISPLACEMENT: require('../../assets/img/跳闸.png'),
         DEVICE_FAILURE: require('../../assets/img/设备.png'),
        

}
    export default {
        props: {
            data: Object
        },
        data() {
            return {
                isShowDetail: false,
                accidentDetailStatus: 'loaded',
                detail: null,
                timer: null,
            }
        },
        methods: {
            async showDetail(code) {
                // console.log(code ,'我来了');
                this.accidentDetailStatus = 'loading';
                this.isShowDetail = true;

                this.detail = await this.getAccidentDetail(code);
                // console.log(this.detail);
                if (this.detail == null) {
                    this.accidentDetailStatus = 'error';
                }
                // console.log(this.detail);
                this.accidentDetailStatus = 'loaded';
                // 标记事件已读
                !this.data.isRead && this.setIsRead(code) && this.$store.commit('setNotifycationIsRead', code);
            },
            closeDetail() {
                this.isShowDetail = false;
            },
            // '从消息提醒列表中彻底删除这条消息',
            remove(id) {
                this.$confirm('<p>确认删除这条消息吗?</p><p>从消息提醒列表中彻底删除这条消息。</p>', {
                        type: 'warning',
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        showClose: false,
                        dangerouslyUseHTMLString: true,
                        customClass: 'notifycation-comfirm'
                    })
                    .then(() => {
                        !this.data.isRead ?
                            this.setIsRead(id) && this.$store.commit('removeData', id) :
                            this.$store.commit('removeData', id)
                        this.$message({
                            type: 'success',
                            message: '删除成功'
                        });
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: '取消删除'
                        });
                    })
            },

            transformForData(response) {
                const {
                    code,
                    data,
                    status
                } = response.data;
                if (code !== 200 || status !== true) {
                    console.error('response error: code is not 200 or status is not true');
                    return null;
                }

                return data;
            },
            accidentDetailMapper(data) {
                // console.log(data)
                return {
                    loopId: data.loop_id,
                    img: data.device_img,
                    name: data.loop_name,
                    deviceName: data.device_name,
                    position: data.area_name,
                    code: data.id,
                    classify: data.alarm_event_type,
                    type: data.alarm_type_desc,
                    start: data.start_time,
                    end: data.end_time,
                    description: data.alarm_type_desc,
                    node: data.node,
                    isRead: data.read_check,
                    realName: data.real_name,
                    event_name:data.event_name,
                     device:data.device_details,
                    loop_type:data.loop_type
                }
            },
            accidentValueMapper(data, node,type) {
                let snapshot = data.results[0].series;
                // console.log(snapshot);
                if(snapshot==undefined){
                    return []
                }
                let temps = snapshot.map(item => {
                    return [item.tags.node, item.values[0][1]];
                });
                let map = new Map(temps);
                //console.log(map);
                return this.accidentValueFormat(map, node,type);
            },
              accidentValueFormat(map, node,type) {
                // console.log(node)
                if(type.classify=='TELEMETRY_OVERRUN'&&type.loop_type=='TRANSFORMER'){
                    return [{
                            title: '温度',
                            unit: '℃',
                            isDangerous: ['Temperature_A', 'Temperature_B', 'Temperature_C'].includes(node),
                            value: [{
                                    name: 'A',
                                    value: map.get('Temperature_A')?map.get('Temperature_A').toFixed(2):map.get('Temperature_A'),
                                    isDangerous: ['Temperature_A'].includes(node),
                                },
                                {
                                    name: 'B',
                                    value: map.get('Temperature_B')?map.get('Temperature_B').toFixed(2):map.get('Temperature_B'),
                                    isDangerous: ['Temperature_B'].includes(node),
                                },
                                {
                                    name: 'C',
                                    value: map.get('Temperature_C')?map.get('Temperature_C').toFixed(2):map.get('Temperature_C'),
                                    isDangerous: ['Temperature_C'].includes(node),
                                },
                                // {name: '均', value: map.get('Vvavg')},
                            ]
                        }, {
                            title: '风机状态',

                            isDangerous: [this.fengji].includes(node),

                            value: [{
                                isDangerous: [this.fengji].includes(node),
                                value: map.get(this.fengji)
                            }]
                        }, {
                            title: '',
                            unit: '',
                            isDangerous: '',
                            value: ''
                        }, {
                            title: '',
                            unit: '',
                            isDangerous: '',
                            value: ''
                        }, {
                            title: '',
                            unit: '',
                            isDangerous: '',
                            value: ''
                        }, {
                            title: '',
                            unit: '',
                            isDangerous: '',
                            value: ''
                        }, {
                            title: '',
                            unit: '',
                            isDangerous: '',
                            value: ''
                        }, {
                            title: '',
                            unit: '',
                            isDangerous: '',
                            value: ''
                        }, {
                            title: '负载',
                            unit: 'V',
                            value: (map.get('P') / 1000)?(map.get('P') / 1000).toFixed(2):(map.get('P') / 1000),
                            value: [{
                                isDangerous: ['P'].includes(node),
                                value: (map.get('P') / 1000).toFixed(2)
                            }, ]
                        }, {
                            title: '负载率',
                            unit: '%',
                            value: (map.get('P') / 1000)?(map.get('P') / 1000).toFixed(2):(map.get('P') / 1000),
                            value: [{
                                isDangerous: this.fengji.includes(node),
                                value: map.get(this.fengji)?map.get(this.fengji).toFixed(2):map.get(this.fengji)
                            }, ]
                        },
                        {
                            title: '容量',
                            unit: 'kVA',
                            value: (map.get('P') / 1000)?(map.get('P') / 1000).toFixed(2):(map.get('P') / 1000),
                            value: [{
                                isDangerous: this.fengji.includes(node),

                            }, ]
                        }
                    ]   
                }else{
                    return [{
                        title: '三相相电压',
                        unit: 'V',
                        isDangerous: ['Ua', 'Ub', 'Uc', 'Vvavg'].includes(node),
                        value: [{
                                name: 'A',
                                value: map.get('Ua')?map.get('Ua').toFixed(2):map.get('Ua')
                            },
                            {
                                name: 'B',
                                value: map.get('Ub')?map.get('Ub').toFixed(2):map.get('Ub')
                            },
                            {
                                name: 'C',
                                value: map.get('Uc')?map.get('Uc').toFixed(2):map.get('Uc')
                            },
                            // {name: '均', value: map.get('Vvavg')},
                        ]
                    }, {
                        title: '三相线电压',
                        unit: 'V',
                        isDangerous: ['Uab', 'Ubc', 'Uac', 'Vlavg'].includes(node),
                        value: [{
                                name: 'AB',
                                value: map.get('Uab')?map.get('Uab').toFixed(2):map.get('Uab')
                            },
                            {
                                name: 'BC',
                                value: map.get('Ubc')?map.get('Ubc').toFixed(2):map.get('Ubc')
                            },
                            {
                                name: 'AC',
                                value: map.get('Uac')?map.get('Uac').toFixed(2):map.get('Uac')
                            },
                            // {name: '均', value: map.get('Vlavg')},
                        ]
                    }, {
                        title: '电流',
                        unit: 'A',
                        isDangerous: ['Ia', 'Ib', 'Ic', 'Iavg'].includes(node),
                        value: [{
                                name: 'A',
                                value: map.get('Ia')?map.get('Ia').toFixed(2):map.get('Ia')
                            },
                            {
                                name: 'B',
                                value: map.get('Ib')?map.get('Ib').toFixed(2):map.get('Ib')
                            },
                            {
                                name: 'C',
                                value: map.get('Ic')?map.get('Ic').toFixed(2):map.get('Ic')
                            },
                            // {name: '均', value: map.get('Iavg')},
                        ]
                    }, {
                        title: '有功功率',
                        unit: 'W',
                        isDangerous: ['PAa', 'PAb', 'PAc', 'PA'].includes(node),
                        value: [{
                                name: 'A',
                                value: map.get('PAa')?map.get('PAa').toFixed(2):map.get('PAa')
                            },
                            {
                                name: 'B',
                                value: map.get('PAb')?map.get('PAb').toFixed(2):map.get('PAb')
                            },
                            {
                                name: 'C',
                                value: map.get('PAc')?map.get('PAc').toFixed(2):map.get('PAc')
                            },
                            // {name: '总', value: map.get('PA')}
                        ]
                    }, {
                        title: '无功功率',
                        unit: 'W',
                        isDangerous: ['PRa', 'PRb', 'PRc', 'PR'].includes(node),
                        value: [{
                                name: 'A',
                                value: map.get('PRa')?map.get('PRa').toFixed(2):map.get('PRa')
                            },
                            {
                                name: 'B',
                                value: map.get('PRb')?map.get('PRb').toFixed(2):map.get('PRb')
                            },
                            {
                                name: 'C',
                                value: map.get('PRc')?map.get('PRc').toFixed(2):map.get('PRc')
                            },
                            // {name: '总', value: map.get('PR')},
                        ]
                    }, {
                        title: '温度',
                        unit: '℃',
                        isDangerous: ['Temperature'].includes(node),
                        value: [{
                            name: 'T',
                            value: map.get('Temperature')
                        }, ]
                    }, {
                        title: '频率',
                        unit: 'Hz',
                        isDangerous: ['F'].includes(node),
                        value: [{
                            name: 'F',
                            value: map.get('F')
                        }, ]
                    }]
                }
              
                },
            
            async setIsRead(id) {
                let response = await SetAccidentRead([id]);
                if (response.data.code === 200 &&
                    response.data.status === true &&
                    response.data.msg === '状态更新成功') {

                    this.$store.commit('totalSub')
                    return true;
                }
                return false;
            },
            async getAccidentDetail(id) {
                let result = await Promise.all([GetAccidentDetailForId(id), GetAccidentValue(id)]);
                let result0 = this.transformForData(result[0]);
                let result1 = this.transformForData(result[1]);
                // console.log(result0, result1)

                if (result0.details === null || result1.snapshot === null) {
                    return;
                }
                result0.details = this.accidentDetailMapper(result0.details);
                result1.snapshot = this.accidentValueMapper(result1.snapshot, result0.details.node,result0.details).filter((
                    item) => {
                    let obj = JSON.parse(result0.details.device)
                    if (item.title == '风机状态') {
                        if (item.value[0].value == 0) {
                            item.value[0].value = '关闭'

                        } else if (item.value[0].value > 0) {
                            item.value[0].value = '开启'
                        }
                    } else if (item.title == '负载') {

                        if (fzl == 0 || rl == 0) {
                            this.all = 0
                        } else {
                            var fzl = item.value[0].value
                            var rl = obj.电气.容量.split('k')
                            // console.log(fzl, rl[0])
                            this.all = fzl / rl[0]*100
                        }
                        // console.log(this.all)
                    } else if (item.title == '容量') {
                        item.value[0].value = obj.电气.容量.split('kVA')[0]
                    } else if (item.title == '负载率') {
                        // console.log(this.all)
                        item.value[0].value = this.all
                    }


                    return item
                });

                return {
                    infomation: result0.details,
                    data: result1.snapshot
                };;
                // console.log(result0.details,result1.snapshot)

                return {
                    infomation: result0.details,
                    data: result1.snapshot
                };
            }
        },
        computed: {
            fengji: function () {

                if (this.$store.state.project.currentProject.projectId == 4) {
                    return "Temperature_status_windopen"
                    //  console.log(value)
                } else {
                    return "Fan_Status"
                    //  console.log(value)
                }
            },
            img: function () {
                return IMAGE[this.data.classify];
            },
        },
        filters: {
            diff: function (value) {
                return dateTimeStamp(Date.parse(value));
            },
        },
        components: {
            Details
        },
        mounted() {
            this.timer = setInterval(() => {
                // console.log('触发刷新');
                this.$forceUpdate();
            }, 60000)
        },
        beforeDestroy() {
            //console.log('销毁定时器')
            if (this.timer) {
                clearInterval(this.timer);
            }
        }
    }
</script>

<style lang="less" scoped>
    .accident-item-container {
        display: flex;
        justify-content: space-between;
        .h(104);
        width: calc(100% - 48rem);
        margin: 0 24rem;
        border-bottom: 1px solid rgba(0, 0, 0, 0.06);
        cursor: pointer;
        flex-shrink: 0;

        .accident-item-infomation {
            display: flex;
            align-items: center;
            flex: 1;

            .accident-item-img-warpper {
                width: 56rem;
                height: 56rem;

                :nth-child(1) {
                    width: 100%;
                }
            }

            .accident-item-content {
                margin-left: 22rem;
                display: flex;
                flex-direction: column;
                justify-content: space-around;
                height: 55%;

                .accident-item-name {
                    font-size: 18rem;
                    font-weight: bold;
                    color: #333333;
                    width: 350rem;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }

                .accident-item-time {
                    font-size: 16rem;
                    font-weight: 400;
                    color: #999999;
                }
            }
        }

        .accident-item-operation {
            display: flex;
            width: 20%;
            justify-content: space-between;
            align-items: center;

            img {
                transform: rotate(270deg);
                cursor: pointer;
            }

            .accident-item-delete {
                visibility: hidden;
                cursor: pointer;

                font-size: 16rem;
                font-weight: 400;
                color: #999999;
            }
        }
    }

    .accident-item-container:hover .accident-item-delete {
        visibility: visible;
    }
</style>